
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","stroke":"#979797","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke-width":".4","cx":"20","cy":"20","r":"19.8"}}),_c('path',{attrs:{"d":"M22.43 15.5c-.79 0-1.539.272-2.106.755l-.324.276-.324-.276a3.246 3.246 0 00-2.106-.755c-1.704 0-3.07 1.25-3.07 2.772a2.6 2.6 0 00.69 1.75c.334.37 1.923 1.866 4.725 4.448.043.04.127.04.174-.004 2.757-2.535 4.333-4.02 4.69-4.412.475-.525.721-1.137.721-1.782 0-1.521-1.366-2.772-3.07-2.772z"}})])])
          )
        }
      }
    